<goab-container class="verified-info" accent="filled" type="non-interactive" padding="relaxed">
  <div class="top-row">
    <h3>Verified Information</h3>
    <goab-icon-button
      variant="dark"
      size="medium"
      icon="lock-closed"
      disabled="true"
      class="lock-icon"
    ></goab-icon-button>
  </div>
  <goab-grid minChildWidth="100%" class="grid-container">
    @if (isVisible('name')){
    <div>
      <span class="value" data-cy="verifiedName">
        {{ getFullName(profileData?.firstName, profileData?.lastName, profileData?.middleName) }}</span
      >
    </div>
    } @if (isVisible('sex')){
    <div>
      <span class="prompt" [textContent]="'Sex:'"></span>
      <span class="value" data-cy="verifiedSex" [textContent]="profileData?.gender?.displayValue || '-'"></span>
    </div>
    } @if (isVisible('dob')){
    <div>
      <span class="prompt" [textContent]="'Date of birth:'"></span>
      <span
        class="value"
        data-cy="verifiedDob"
        [textContent]="(profileData?.dateOfBirth | date: 'longDate':'+0000') || '-'"
      ></span>
    </div>
    }
  </goab-grid>
</goab-container>
